(function () {
  'use strict';

  var FRESH_TAG = 'umedmart-fresh';
  var PGB_GIFT_PROPERTY = '_salepify-progress-bar';
  var MODE_STORAGE_KEY = 'salepify-cart-widget-mode';
  var RULE_IDS = {
    fresh: { pgb: '6322', ymal: 503 },
    standard: { pgb: '6323', ymal: 499 }
  };
  var tagCache = {};
  var cartPreview = {
    mode: null,
    instance: null,
    pending: false,
    originalElement: null,
    originalHtml: null,
    originalPointerEvents: null,
    syncTimer: null,
    lastDiagnostic: null,
    scope: null
  };
  var state = {
    mode: 'standard',
    hasNormalItems: false,
    itemCount: 0,
    debug: window.SalepifyCartWidgetRuleSelectorConfig?.debug !== false
  };

  function log(label, data) {
    if (state.debug) window.console?.log?.('[Salepify cart selector] ' + label, data);
  }

  function normalItems(items) {
    return (Array.isArray(items) ? items : []).filter(function (item) {
      return !item?.properties?.[PGB_GIFT_PROPERTY];
    });
  }

  function hasFreshTag(item) {
    return (Array.isArray(item?.tags) ? item.tags : []).some(function (tag) {
      return String(tag).toLowerCase() === FRESH_TAG;
    });
  }

  function select(items) {
    var normal = normalItems(items);
    state.hasNormalItems = normal.length > 0;
    state.itemCount = normal.length;
    state.mode = normal.some(hasFreshTag) ? 'fresh' : 'standard';
    return state.mode;
  }

  function scopeItems() {
    return Array.isArray(window.SalepifyCartWidgetScope?.items)
      ? window.SalepifyCartWidgetScope.items
      : [];
  }

  function readSavedMode() {
    try {
      var saved = window.sessionStorage?.getItem(MODE_STORAGE_KEY);
      return saved === 'fresh' || saved === 'standard' ? saved : null;
    } catch (_error) {
      return null;
    }
  }

  function saveMode(mode) {
    try {
      window.sessionStorage?.setItem(MODE_STORAGE_KEY, mode);
    } catch (_error) {
      // sessionStorage can be disabled by browser privacy settings.
    }
  }

  function setItems(items) {
    window.SalepifyCartWidgetScope = window.SalepifyCartWidgetScope || {};
    window.SalepifyCartWidgetScope.items = Array.isArray(items) ? items : [];
    select(window.SalepifyCartWidgetScope.items);
    return state.mode;
  }

  async function tagsForHandle(handle) {
    if (!handle) return null;
    if (tagCache[handle]) return tagCache[handle];
    try {
      var response = await window.fetch('/products/' + encodeURIComponent(handle) + '.js');
      if (!response.ok) return null;
      var product = await response.json();
      if (!Array.isArray(product?.tags)) return null;
      tagCache[handle] = product.tags;
      return tagCache[handle];
    } catch (error) {
      log('could not load product tags', { handle: handle, error: error });
      return null;
    }
  }

  async function hydrateTags(items) {
    var nextItems = Array.isArray(items) ? items : [];
    var resolved = true;
    await Promise.all(nextItems.map(async function (item) {
      if (Array.isArray(item?.tags)) return;
      var tags = await tagsForHandle(item?.handle);
      if (tags === null) {
        resolved = false;
        return;
      }
      item.tags = tags;
    }));
    return { items: nextItems, resolved: resolved };
  }

    async function refreshFromCartMutation(cart) {
    var previousMode = state.mode;
    var hydrated = await hydrateTags(cart?.items || []);
    if (!hydrated.resolved) {
      log('cart mutation ignored: tags not resolved', { previousMode: previousMode });
      return;
    }
    var nextMode = setItems(hydrated.items);
    log('cart mutation evaluated', {
      previousMode: previousMode,
      nextMode: nextMode,
      items: hydrated.items.map(function (item) {
        return { handle: item.handle, tags: item.tags || [] };
      })
    });
    saveMode(nextMode);

    // Đồng bộ lại giỏ cho instance preview
    if (cartPreview.instance && typeof cartPreview.instance.updateCartTotal === 'function') {
      cartPreview.instance.updateCartTotal();
    } else {
      mountCartPreview();
    }
  }


  function getRules() {
    return window.SalepifyPgbRawRules || window.tlCartGoalRules || null;
  }

  function getRule(ruleId) {
    var rules = getRules();
    if (!rules || typeof rules !== 'object') return null;
    var key = Object.keys(rules).find(function (candidate) {
      return String(candidate).split('_')[0] === String(ruleId) || String(rules[candidate]?.id) === String(ruleId);
    });
    return key ? rules[key] : null;
  }

  function getCartDrawerHost() {
    var title = Array.from(document.querySelectorAll('body *')).find(function (el) {
      return !['SCRIPT', 'STYLE'].includes(el.tagName) && (el.innerText || '').trim() === 'Your cart';
    });
    if (!title) {
      // Broadcast renders the mini cart in a component boundary on this
      // storefront. Querying body cannot cross that boundary, but hit-testing
      // the visible cart-title area can still return its host.
      var point = document.elementFromPoint(
        Math.min(100, Math.max(20, window.innerWidth * 0.2)),
        Math.min(95, Math.max(40, window.innerHeight * 0.12))
      );
      if (!point) return null;
      var root = point.getRootNode?.();
      if (root?.host) return root;
      var fallback = point.closest(
        '[role="dialog"], cart-drawer, [data-cart-drawer], #CartDrawer, #cartDrawer, ' +
        '[class*="side-cart"], [class*="cart-drawer"], [class*="cartdrawer"]'
      );
      return fallback || point.parentElement?.parentElement || null;
    }

    var host = title.closest(
      '[role="dialog"], cart-drawer, [data-cart-drawer], #CartDrawer, #cartDrawer, ' +
      '[class*="side-cart"], [class*="cart-drawer"], [class*="cartdrawer"]'
    );
    return host || title.parentElement?.parentElement || null;
  }

  function getCartSlot() {
    var host = getCartDrawerHost();
    if (!host) return null;
    var slot = host.querySelector('#salepify-cart-widget-slot');
    if (slot) return slot;

    slot = document.createElement('div');
    slot.id = 'salepify-cart-widget-slot';
    slot.style.pointerEvents = 'none';
    var anchor = host.querySelector('.drawer__message--milestones');
    if (anchor) anchor.insertAdjacentElement('afterend', slot);
    else host.append(slot);
    return slot;
  }

  function isVisible(element) {
    if (!element) return false;
    var style = window.getComputedStyle ? window.getComputedStyle(element) : null;
    var rect = element.getBoundingClientRect?.();
    return (!style || (style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0')) &&
      (!rect || (rect.width > 0 && rect.height > 0));
  }

  function getVisibleCartTitle() {
    return Array.from(document.querySelectorAll('body *')).find(function (element) {
      return !['SCRIPT', 'STYLE'].includes(element.tagName) &&
        (element.innerText || '').trim() === 'Your cart' && isVisible(element);
    }) || null;
  }

  function getOpenCartDrawer() {
    // On this theme `.side-cart` is only an absolute wrapper; the actual
    // visible drawer and its PGB live inside `.side-cart-inner`.
    return Array.from(document.querySelectorAll('.side-cart-inner, .side-cart, cart-drawer, [data-cart-drawer], #CartDrawer, #cartDrawer'))
      .find(isVisible) || null;
  }

  function isCartDrawerOpen() {
    return document.body.classList.contains('side-cart-open') ||
      document.documentElement.classList.contains('side-cart-open') ||
      Boolean(getOpenCartDrawer()) ||
      Boolean(getVisibleCartTitle());
  }

  function syncOriginalProductWidget() {
    // Only the drawer widget needs restoring on close. A main-cart-page
    // override has no "closed" state to revert to while the page is live.
    if (cartPreview.scope !== 'drawer') return;
    var drawerIsOpen = isCartDrawerOpen();
    if (drawerIsOpen) return;
    if (cartPreview.syncTimer) {
      window.clearInterval(cartPreview.syncTimer);
      cartPreview.syncTimer = null;
    }
    if (!cartPreview.originalElement) return;
    cartPreview.originalElement.innerHTML = cartPreview.originalHtml;
    cartPreview.originalElement.style.pointerEvents = cartPreview.originalPointerEvents;
    cartPreview.originalElement = null;
    cartPreview.originalHtml = null;
    cartPreview.originalPointerEvents = null;
    cartPreview.scope = null;
    log('restored product widget after drawer close', null);
  }

  function getDrawerPgbWidget() {
    // On this storefront the theme relocates PGB visually after the cart AJAX
    // update, but the widget can remain outside `.side-cart-inner` in the DOM.
    // Prefer a nested widget, then identify the visible drawer widget by its
    // rendered rectangle rather than by parent-child ownership.
    var drawer = document.querySelector('.side-cart-inner');
    if (!drawer) return null;
    var widgets = Array.from(document.querySelectorAll('.tl-custom-cart-goal-container'));
    var nested = Array.from(drawer.querySelectorAll('.tl-custom-cart-goal-container')).find(function (widget) {
      return /away from getting|Congratulations!/i.test(widget.innerText || '');
    });
    if (nested) return nested;

    var drawerRect = drawer.getBoundingClientRect?.();
    if (!drawerRect || !drawerRect.width || !drawerRect.height) return null;
    return widgets.find(function (widget) {
      if (!/away from getting|Congratulations!/i.test(widget.innerText || '')) return false;
      var rect = widget.getBoundingClientRect?.();
      if (!rect || !rect.width || !rect.height) return false;
      var centerX = rect.left + (rect.width / 2);
      var centerY = rect.top + (rect.height / 2);
      return centerX >= drawerRect.left && centerX <= drawerRect.right &&
        centerY >= drawerRect.top && centerY <= drawerRect.bottom;
    }) || null;
  }

  function isGoalWidgetText(widget) {
    return /away from getting|Congratulations!/i.test(widget?.innerText || '');
  }

  function isMainCartPage() {
    return document.body.classList.contains('template-cart');
  }

  function getMainCartPgbWidget() {
    // The standalone /cart page has no drawer wrapper; the app renders its
    // goal widget directly in the page body, so find it outside the drawer.
    var drawer = document.querySelector('.side-cart-inner');
    var widgets = Array.from(document.querySelectorAll('.tl-custom-cart-goal-container'));
    return widgets.find(function (widget) {
      return isGoalWidgetText(widget) && isVisible(widget) && (!drawer || !drawer.contains(widget));
    }) || null;
  }

  function getPgbTarget() {
    if (isCartDrawerOpen()) {
      var drawerWidget = getDrawerPgbWidget();
      if (drawerWidget) return { element: drawerWidget, scope: 'drawer' };
    }
    if (isMainCartPage()) {
      var mainCartWidget = getMainCartPgbWidget();
      if (mainCartWidget) return { element: mainCartWidget, scope: 'main-cart' };
    }
    return null;
  }

  function htmlText(html) {
    if (!html || !document.createElement) return '';
    var scratch = document.createElement('div');
    scratch.innerHTML = html;
    return (scratch.innerText || scratch.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function previewDiagnostic(stage, extra) {
    if (!state.debug) return;
    var widgets = Array.from(document.querySelectorAll('.tl-custom-cart-goal-container'));
    var data = Object.assign({
      stage: stage,
      mode: state.mode,
      expectedRuleId: RULE_IDS[state.mode].pgb,
      drawerOpen: isCartDrawerOpen(),
      bodyClass: document.body.className,
      htmlClass: document.documentElement.className,
      visibleCartTitleFound: Boolean(getVisibleCartTitle()),
      drawerClass: String(getOpenCartDrawer()?.className || ''),
      widgetCount: widgets.length,
      widgets: widgets.map(function (widget) {
        var rect = widget.getBoundingClientRect?.();
        var style = window.getComputedStyle ? window.getComputedStyle(widget) : null;
        return {
          text: (widget.innerText || '').replace(/\s+/g, ' ').trim().slice(0, 180),
          className: widget.className,
          rect: rect ? {
            left: Math.round(rect.left),
            top: Math.round(rect.top),
            width: Math.round(rect.width),
            height: Math.round(rect.height)
          } : null,
          display: style?.display,
          visibility: style?.visibility,
          zIndex: style?.zIndex,
          parentClass: String(widget.parentElement?.className || ''),
          grandparentClass: String(widget.parentElement?.parentElement?.className || '')
        };
      })
    }, extra || {});
    var signature = JSON.stringify(data);
    if (signature === cartPreview.lastDiagnostic) return;
    cartPreview.lastDiagnostic = signature;
    log('PGB cart render diagnostic', data);
  }

  function renderPreview() {
    if (!window.document) return;
    if (!cartPreview.instance || typeof cartPreview.instance.renderCartGoal !== 'function') {
      previewDiagnostic('missing-preview-instance');
      return;
    }
    var html = cartPreview.instance.renderCartGoal(0);
    if (!html) {
      previewDiagnostic('clone-returned-empty-html');
      return;
    }
    var target = getPgbTarget();
    if (!target) {
      previewDiagnostic('PGB-node-not-found', { cloneText: htmlText(html).slice(0, 220) });
      return;
    }
    var widget = target.element;
    if (cartPreview.originalElement !== widget) {
      cartPreview.originalElement = widget;
      cartPreview.originalHtml = widget.innerHTML;
      cartPreview.originalPointerEvents = widget.style.pointerEvents;
    }
    cartPreview.scope = target.scope;
    // The native PGB continues to re-render after cart AJAX events.  Only
    // replace its output when it differs, so this remains display-only and
    // does not create a MutationObserver/render loop.
    if (widget.innerHTML !== html) {
      widget.innerHTML = html;
      widget.style.pointerEvents = 'none';
      log('cart display rendered', { mode: cartPreview.mode, scope: target.scope, target: '.tl-custom-cart-goal-container' });
    }
    previewDiagnostic('rendered-or-already-current', {
      scope: target.scope,
      cloneText: htmlText(html).slice(0, 220),
      visibleText: (widget.innerText || '').replace(/\s+/g, ' ').trim().slice(0, 220)
    });
  }

  function renderPreviewAfterCorePasses() {
    [0, 200, 800].forEach(function (delay) {
      (window.setTimeout || setTimeout)(renderPreview, delay);
    });
  }

  function keepCartPreviewInSync() {
    if (cartPreview.syncTimer || !window.setInterval) return;
    var attempts = 0;
    cartPreview.syncTimer = window.setInterval(function () {
      attempts += 1;
      renderPreview();
      // Allow the native app's delayed render passes to finish, then rely on
      // the drawer-specific MutationObserver for later cart AJAX updates.
      if (attempts >= 16) {
        window.clearInterval(cartPreview.syncTimer);
        cartPreview.syncTimer = null;
        return;
      }
    }, 250);
  }

    // --- HÀM BẢO VỆ TOÀN DIỆN KHÔNG CHO INSTANCE GỐC XÓA QUÀ FRESH ---
  function patchEmbedProtection() {
    // 1. Chặn ngay tại hàm handleRemoveGift của instance gốc
    var original = window.tlCartGoalEmbed;
    if (original && !original._ruleProtectionPatched) {
      var originalHandleRemoveGift = original.handleRemoveGift;
      if (typeof originalHandleRemoveGift === 'function') {
        original.handleRemoveGift = async function () {
          var activeRuleId = String(RULE_IDS[state.mode]?.pgb);
          var currentEmbedRuleId = original.cartGoal?.id ? String(original.cartGoal.id) : null;

          // Nếu instance gốc đang mang rule khác với mode hiện tại (vd gốc là 6323 mà mode là fresh 6322)
          // -> Chặn đứng hoàn toàn, không cho phép xóa bất cứ quà nào!
          if (currentEmbedRuleId && currentEmbedRuleId !== activeRuleId) {
            log('blocked original embed handleRemoveGift: embed rule is ' + currentEmbedRuleId + ' but active mode is ' + activeRuleId);
            return false;
          }

          return originalHandleRemoveGift.apply(this, arguments);
        };
      }
      original._ruleProtectionPatched = true;
      log('patched handleRemoveGift protection on original embed');
    }

    // 2. Chốt chặn tầng 2: Chặn trực tiếp request /cart/update.js?app=salepify xóa quà của active rule
    if (!window._salepifyFetchProtectionPatched) {
      var nativeFetch = window.fetch;
      window.fetch = async function (resource, init) {
        var url = typeof resource === 'string' ? resource : (resource?.url || '');
        if (url.indexOf('cart/update.js?app=salepify') !== -1 && init?.body) {
          try {
            var payload = JSON.parse(init.body);
            if (payload && payload.updates && typeof payload.updates === 'object') {
              var activeRuleId = String(RULE_IDS[state.mode]?.pgb);
              var cartItems = window.SalepifyCartWidgetScope?.items || [];
              
              // Nếu trong updates có key của món quà thuộc active rule (6322) -> GỠ BỎ KHỎI UPDATES!
              Object.keys(payload.updates).forEach(function (key) {
                var item = cartItems.find(function (it) { return it.key === key; });
                var prop = item?.properties?.[PGB_GIFT_PROPERTY];
                if (prop && String(prop).split('-')[0] === activeRuleId) {
                  delete payload.updates[key];
                  log('intercepted & blocked deleting active gift line', { key: key });
                }
              });

              // Nếu không còn gì cần xóa nữa thì hủy request update luôn, trả về cart hiện tại
              if (Object.keys(payload.updates).length === 0) {
                log('canceled cart/update.js request completely because all items were active gifts');
                return nativeFetch.call(this, '/cart.js');
              }
              init.body = JSON.stringify(payload);
            }
          } catch (_err) {}
        }
        return nativeFetch.apply(this, arguments);
      };
      window._salepifyFetchProtectionPatched = true;
      log('installed fetch interceptor for cart/update.js');
    }
  }


    function mountCartPreview() {
    if (!window.document) return;
    patchEmbedProtection();

    var ruleId = RULE_IDS[state.mode].pgb;
    
    // NẾU INSTANCE ĐÃ TỒN TẠI: Gọi updateCartTotal() để nó đồng bộ quà trong giỏ
    if (cartPreview.mode === state.mode && cartPreview.instance) {
      if (typeof cartPreview.instance.updateCartTotal === 'function') {
        cartPreview.instance.updateCartTotal();
      } else {
        renderPreviewAfterCorePasses();
      }
      return;
    }

    var original = window.tlCartGoalEmbed;
    var CartGoalEmbed = original?.constructor;
    var rule = getRule(ruleId);
    if (!CartGoalEmbed || !rule || !window.tlCartGoalRules || cartPreview.pending) return;

    cartPreview.pending = true;
    var displayRule = JSON.parse(JSON.stringify(rule));
    displayRule.auto_add_reward = rule.auto_add_reward !== false;

    displayRule.auto_remove_gift = false;

    try {
      var instance = new CartGoalEmbed(
        window.tlCartGoalIsRestricted,
        { [String(ruleId)]: displayRule },
        window.tlCartGoalGiftSVG,
        window.tlCartGoalDiscountSVG,
        window.tlCartGoalFreeShippingSVG,
        window.tlCartGoalCurrencySymbol,
        window.tlCartGoalCartTotal,
        window.tlCartGoalTemplate,
        window.tlCartGoalDefaultImage,
        window.tlCartGoalShowTrademark,
        window.tlCartGoalProductIdMapCollection,
        window.tlCartGoalDisplaySetting,
        window.tlCartGoalTranslation,
        window.tlCartGoalCustomer,
        window.tlCartGoalCartType,
        window.tlCartGoalPriceCalculation
      );
      instance.renderAllCartGoals = renderPreview;
      instance.updateCartAttribute = function () { return Promise.resolve(); };
      instance.trackImpression = function () {};
      cartPreview.mode = state.mode;
      cartPreview.instance = instance;
      cartPreview.lastDiagnostic = null;
      log('mounted cart display preview', { mode: state.mode, ruleId: ruleId });

      // ĐỒNG BỘ CART NGAY SAU KHI KHỞI TẠO
      if (typeof instance.updateCartTotal === 'function') {
        instance.updateCartTotal();
      } else {
        renderPreviewAfterCorePasses();
      }
      keepCartPreviewInSync();
    } catch (error) {
      log('could not mount cart display preview', error);
    } finally {
      cartPreview.pending = false;
    }
  }


  async function hydrateLiveCart() {
    try {
      var response = await window.fetch('/cart.js');
      if (!response.ok) return;
      var cart = await response.json();
      log('live cart loaded', {
        itemCount: cart.item_count,
        handles: (cart.items || []).map(function (item) { return item.handle; })
      });
      await refreshFromCartMutation(cart);
    } catch (error) {
      log('could not load live cart', error);
    }
  }

  select(scopeItems());
  if (!state.hasNormalItems) {
    var savedMode = readSavedMode();
    if (savedMode) {
      state.mode = savedMode;
      // Liquid cart can be stale on cached storefront pages. Keep the last
      // verified mode active until the next live cart mutation confirms it.
      state.hasNormalItems = true;
      log('restored saved mode', { mode: state.mode });
    }
  }
  log('initial mode', { mode: state.mode, hasNormalItems: state.hasNormalItems, itemCount: state.itemCount });

  window.addEventListener('TLCARTGOAL:mutate', function (event) {
    refreshFromCartMutation(event?.detail);
  });

  if (window.MutationObserver && window.document) new window.MutationObserver(function (records) {
    var relevantNodeWasAdded = records.some(function (record) {
      return Array.from(record.addedNodes).some(function (node) {
        return node.nodeType === 1 && (
          /Your cart/i.test(node.innerText || '') ||
          node.matches?.('.tl-custom-cart-goal-container') ||
          node.querySelector?.('.tl-custom-cart-goal-container') ||
          node.matches?.('cart-drawer, [data-cart-drawer], #CartDrawer, #cartDrawer, [class*="side-cart"], [class*="cart-drawer"]')
        );
      });
    });
    if (relevantNodeWasAdded) {
      mountCartPreview();
      renderPreviewAfterCorePasses();
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (window.MutationObserver && window.document?.body) new window.MutationObserver(function () {
    syncOriginalProductWidget();
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  if (window.MutationObserver && window.document?.documentElement) new window.MutationObserver(function () {
    syncOriginalProductWidget();
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

  (window.setTimeout || setTimeout)(function () {
    patchEmbedProtection();
    hydrateLiveCart();
    mountCartPreview();
  }, 0);

  window.SalepifyCartWidgetRuleSelector = {
    getMode: function () { return state.mode; },
    hasNormalItems: function () { return state.hasNormalItems; },
    getRuleIds: function () { return Object.assign({}, RULE_IDS[state.mode]); },
    refreshFromCartMutation: refreshFromCartMutation,
    inspect: function () {
      return {
        mode: state.mode,
        hasNormalItems: state.hasNormalItems,
        itemCount: state.itemCount,
        ruleIds: Object.assign({}, RULE_IDS[state.mode]),
        debug: state.debug
      };
    }
  };
}());
